import { changeView as _changeView } from '../../actions/view';
import { emit as _emit } from '../../actions/events';
import { merge as _merge } from '../../actions/social';
import { emailSelector, hasErrorSelector, hasMerdgeErrorSelector, isSubmittingSelector, mergeErrorSelector, socialLoginIdSelector, socialTypeSelector } from './selectors';
import { SocialMergeViewContainer as Component } from './SocialMergeViewContainer';
import { connect } from 'react-redux';

function mapStateToProps(state) {
  return {
    hasInitialError: hasErrorSelector(state),
    isSubmitting: isSubmittingSelector(state),
    email: emailSelector(state),
    socialLoginId: socialLoginIdSelector(state),
    socialType: socialTypeSelector(state),
    hasMergeError: hasMerdgeErrorSelector(state),
    mergeError: mergeErrorSelector(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeView: function changeView(view, data) {
      dispatch(_changeView(view, data));
    },
    emit: function emit(type, event) {
      dispatch(_emit(type, event));
    },
    merge: function merge(params) {
      dispatch(_merge(params));
    }
  };
}

export var SocialMergeViewContainer = connect(mapStateToProps, mapDispatchToProps)(Component);